import type { CommerceTranslation } from './types';

/** Hindi. Pending review by native speakers. */
export const commerceHi: CommerceTranslation = {
  nav: { orders: 'ऑर्डर', finance: 'वित्तीय अपवाद' },
  orders: {
    title: 'ऑर्डर',
    description: 'चैट में दिए गए ऑर्डर। भुगतान और रिफ़ंड की स्थिति भुगतान प्रदाता से आती है, चैट से नहीं।',
    search: 'ऑर्डर नंबर से खोजें',
    needsAttention: 'केवल वे ऑर्डर जिन पर ध्यान देना है',
    empty: 'अभी कोई ऑर्डर नहीं है।',
    emptyFiltered: 'कोई ऑर्डर मेल नहीं खाता।',
    clearFilters: 'सभी ऑर्डर दिखाएँ',
    loading: 'ऑर्डर लोड हो रहे हैं',
    columns: {
      reference: 'ऑर्डर',
      customer: 'ग्राहक',
      placed: 'दिया गया',
      total: 'कुल',
      payment: 'भुगतान',
      fulfilment: 'डिलीवरी',
      attention: 'ध्यान देना है',
    },
    visitor: 'विज़िटर',
    pendingRefunds_one: '{{count}} रिफ़ंड फ़ैसले का इंतज़ार कर रहा है',
    pendingRefunds_other: '{{count}} रिफ़ंड फ़ैसले का इंतज़ार कर रहे हैं',
    openExceptions_one: '{{count}} अपवाद',
    openExceptions_other: '{{count}} अपवाद',
  },
  payment: {
    not_started: 'भुगतान नहीं हुआ',
    requires_action: 'ग्राहक का इंतज़ार',
    processing: 'पुष्टि हो रही है',
    authorized: 'अधिकृत',
    captured: 'भुगतान हो गया',
    failed: 'विफल',
    cancelled: 'रद्द',
    unknown: 'पुष्टि नहीं हुई',
  },
  orderState: {
    draft: 'ड्राफ़्ट',
    submitted: 'भुगतान का इंतज़ार',
    confirmed: 'पक्का',
    partially_fulfilled: 'कुछ हिस्सा पूरा',
    fulfilled: 'पूरा',
    cancel_requested: 'रद्द करने को कहा गया',
    cancelled: 'रद्द',
    returned: 'वापस',
  },
  fulfilment: {
    not_started: 'शुरू नहीं हुआ',
    pending: 'बाकी',
    in_progress: 'चल रहा है',
    delayed: 'देरी',
    shipped: 'भेजा गया',
    delivered: 'डिलीवर हुआ',
    provisioned: 'चालू',
    failed: 'विफल',
    cancelled: 'रद्द',
  },
  detail: {
    loading: 'ऑर्डर लोड हो रहा है',
    back: 'सभी ऑर्डर',
    title: 'ऑर्डर {{reference}}',
    observed: '{{time}} पर रिकॉर्ड से पढ़ा गया।',
    seller: 'विक्रेता',
    customer: 'ग्राहक',
    items: 'आइटम',
    delivery: 'डिलीवरी',
    total: 'कुल',
    payment: 'भुगतान',
    paidAt: 'भुगतान का समय',
    providerRef: 'प्रदाता संदर्भ',
    paid: 'भुगतान हुआ',
    refunded: 'रिफ़ंड हुआ',
    refundable: 'अभी रिफ़ंड हो सकता है',
    fulfilments: 'डिलीवरी',
    noFulfilment: 'अभी डिलीवरी का कोई अपडेट नहीं है।',
    estimate: 'दुकान का अनुमान: {{date}}',
    kind: { shipment: 'शिपमेंट', service: 'सेवा' },
    source: { merchant: 'दुकान के सिस्टम से', staff: 'टीम ने दर्ज किया' },
    tracking: 'ट्रैकिंग नंबर: {{ref}}',
    updated: '{{time}} को अपडेट हुआ',
    operations: 'प्रदाता को भेजे गए अनुरोध',
    operationsDescription: 'भुगतान प्रदाता को भेजा गया हर अनुरोध, और क्या, कहाँ से और कब देखा गया।',
    operationState: {
      pending: 'नहीं भेजा गया',
      dispatched: 'भेजा गया',
      succeeded: 'हो गया',
      failed: 'विफल',
      unknown: 'नतीजा अभी पता नहीं',
      cancelled: 'रद्द',
    },
    receipt: '{{kind}} · {{outcome}} · {{source}} · {{time}}',
    exceptions: 'अपवाद',
  },
  fulfilmentForm: {
    open: 'अपडेट दर्ज करें',
    title: 'डिलीवरी का अपडेट दर्ज करें',
    description: 'दुकान ने जो बताया, वह दर्ज करें। ग्राहक को नई स्थिति चैट में दिखेगी।',
    kind: 'क्या पूरा किया जा रहा है',
    state: 'नई स्थिति',
    estimate: 'अनुमानित तारीख',
    estimateHint: 'सिर्फ़ वह तारीख जो दुकान ने दी है। ग्राहक इसे अनुमान के रूप में देखेगा, वादे के रूप में नहीं।',
    carrierRef: 'ट्रैकिंग नंबर',
    note: 'टीम के लिए नोट',
    noteHint: 'ग्राहक यह नोट नहीं देखता।',
    submit: 'सेव करें और ग्राहक को बताएं',
    saved: 'अपडेट सेव हो गया। ग्राहक इसे चैट में देखेगा।',
  },
  refunds: {
    title: 'रिफ़ंड',
    none: 'अभी कोई रिफ़ंड नहीं है।',
    request: 'रिफ़ंड का अनुरोध करें',
    requestDescription: '{{amount}} तक रिफ़ंड हो सकता है।',
    policyAlways: 'हर रिफ़ंड के लिए किसी दूसरे व्यक्ति की मंज़ूरी चाहिए।',
    policyThreshold: '{{amount}} से ज़्यादा के रिफ़ंड के लिए किसी दूसरे व्यक्ति की मंज़ूरी चाहिए।',
    amount: '{{currency}} में राशि',
    fullOnly: 'यह दुकान सिर्फ़ पूरी रकम लौटा सकती है: {{amount}}।',
    amountHint: 'जैसे 35.00',
    ambiguous: 'आपका मतलब कौन-सी राशि है?',
    invalid: {
      empty: 'राशि दर्ज करें।',
      format: '35.00 जैसी राशि दर्ज करें।',
      precision: '{{currency}} के लिए दशमलव के बाद बहुत ज़्यादा अंक हैं।',
      negative: 'शून्य से ज़्यादा राशि दर्ज करें।',
      too_large: 'यह राशि बहुत बड़ी है।',
      over: 'यह रिफ़ंड की जा सकने वाली राशि से ज़्यादा है।',
    },
    reason: 'कारण',
    reasons: {
      customer_request: 'ग्राहक ने माँगा',
      damaged: 'खराब निकला',
      not_delivered: 'डिलीवर नहीं हुआ',
      duplicate: 'दो बार पैसा कटा',
      other: 'अन्य',
    },
    note: 'टीम के लिए नोट',
    submit: 'रिफ़ंड का अनुरोध करें',
    state: {
      requested: 'अनुरोध किया गया',
      policy_checked: 'जाँचा गया',
      awaiting_approval: 'मंज़ूरी का इंतज़ार',
      submitted: 'प्रदाता को भेजा गया',
      pending: 'प्रदाता के पास बाकी',
      succeeded: 'रिफ़ंड हो गया',
      rejected: 'नामंज़ूर',
      failed: 'विफल',
      unknown: 'नतीजा पक्का नहीं',
    },
    requestedBy: '{{name}} ने माँगा, {{time}}',
    approvedBy: '{{name}} ने मंज़ूर किया, {{time}}',
    rejectedBy: '{{name}} ने नामंज़ूर किया: {{reason}}',
    failureReason: 'प्रदाता ने कहा: {{reason}}',
    approve: 'रिफ़ंड मंज़ूर करें',
    reject: 'नामंज़ूर करें',
    check: 'रिफ़ंड की स्थिति जाँचें',
    approveTitle: '{{amount}} का रिफ़ंड मंज़ूर करें?',
    approveBody:
      'पैसा भुगतान प्रदाता के ज़रिए ग्राहक के भुगतान के तरीके में वापस जाता है। इसे यहाँ से वापस नहीं लिया जा सकता।',
    approveConfirm: 'मंज़ूर करें और भेजें',
    rejectTitle: 'यह रिफ़ंड नामंज़ूर करें?',
    rejectReason: 'क्यों? (टीम इसे देखती है)',
    rejectConfirm: 'रिफ़ंड नामंज़ूर करें',
    samePerson: 'यह रिफ़ंड आपने माँगा है, इसलिए कोई और इसे मंज़ूर करे।',
    noPermission: 'इसका फ़ैसला केवल वे लोग कर सकते हैं जो रिफ़ंड मंज़ूर कर सकते हैं।',
    separateApprover: 'इस रिफ़ंड को माँगने वाले के अलावा कोई और मंज़ूर करे।',
    pendingNote: 'प्रदाता की पुष्टि तक इसे रिफ़ंड हुआ नहीं माना जाता।',
  },
  finance: {
    title: 'वित्तीय अपवाद',
    description:
      'ऐसे भुगतान और रिफ़ंड जिनके नतीजे को किसी व्यक्ति को देखना है। जाँचने से प्रदाता से फिर पूछा जाता है। हल करने से आपका फ़ैसला दर्ज होता है, कोई पैसा नहीं जाता।',
    open: 'खुले',
    resolved: 'हल हुए',
    tabs: 'दिखाएँ',
    empty: 'किसी चीज़ पर ध्यान देने की ज़रूरत नहीं है।',
    emptyResolved: 'अभी कोई हल हुआ अपवाद नहीं है।',
    loading: 'अपवाद लोड हो रहे हैं',
    kind: {
      payment_unknown: 'भुगतान का नतीजा पता नहीं',
      refund_unknown: 'रिफ़ंड का नतीजा पता नहीं',
      order_update_pending: 'भुगतान हुआ, पर ऑर्डर अपडेट नहीं हुआ',
      amount_mismatch: 'राशि अलग है',
      reconcile_exhausted: 'प्रदाता जवाब नहीं दे रहा',
      refund_failed: 'रिफ़ंड विफल',
      provisioning_failed: 'सेवा चालू नहीं हुई',
    },
    action: {
      check_status: 'स्थिति जाँचें',
      wait_for_provider: 'प्रदाता का इंतज़ार करें',
      contact_provider: 'प्रदाता से संपर्क करें',
      review_order: 'ऑर्डर देखें',
      retry_refund: 'जाँचें, फिर ज़रूरत हो तो दोबारा रिफ़ंड करें',
    },
    nextAction: 'अगला सुरक्षित कदम: {{action}}',
    providerState: 'प्रदाता की स्थिति: {{state}}',
    openedAt: '{{time}} से खुला',
    evidence: 'सबूत',
    order: 'ऑर्डर {{reference}}',
    check: 'प्रदाता से जाँचें',
    resolve: 'हल करें',
    resolveTitle: 'यह अपवाद हल करें',
    resolution: 'हल',
    resolutions: {
      provider_confirmed: 'प्रदाता ने नतीजे की पुष्टि की',
      manual_review: 'हाथ से जाँचा गया',
      refunded_elsewhere: 'दूसरे तरीके से रिफ़ंड हुआ',
      written_off: 'बट्टे खाते में डाला गया',
    },
    note: 'आपने क्या जाँचा',
    resolveConfirm: 'अपवाद हल करें',
    resolvedAs: 'हल: {{resolution}}',
  },
};
